module.exports = __webpack_public_path__ + "img/ico-trash-white.561b3b9a.svg";